<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para"><a id="page_vii"></a>SPECIAL THANKS TO:</p>
<p class="linespace"> </p>
<p class="center-para"><em>The ever-helpful:</em></p>
<p class="para"> </p>
<p class="center-para">My wife, Valette, Jake, and Charlie</p>
<p class="para"> </p>
<p class="center-para">My mom, Grace</p>
<p class="para"> </p>
<p class="center-para">Marlene Stringer, the best and most patient agent</p>
<p class="para"> </p>
<p class="center-para">Jason (no Shatner!) Williams, the editor who got it</p>
<p class="linespace"> </p>
<p class="center-para"><em>The ever-faithful:</em></p>
<p class="para"> </p>
<p class="center-para">Virginia Alexander</p>
<p class="para"> </p>
<p class="center-para">Lisa Marie Brodsky</p>
<p class="para"> </p>
<p class="center-para">Jo Carol and Jim Crisp</p>
<p class="para"> </p>
<p class="center-para">Thomas Kopp</p>
<p class="para"> </p>
<p class="center-para">Lisa Krupa</p>
<p class="para"> </p>
<p class="center-para">Lucy Mogensen</p>
<p class="para"> </p>
<p class="center-para">Mary Ann Sabo</p>
<p class="para"> </p>
<p class="center-para">Christi Underdown</p>
<p class="para"> </p>
<p class="center-para">Sarah Vermillion</p>
<p class="para"> </p>
<p class="center-para">The past and present members of Moon’s Inkwell</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication01.vue?b8c66542